module.exports = __webpack_public_path__ + "img/profile.52e4b9ba.jpg";